export default __webpack_public_path__ + "media/titles/title_4_locale_de-8c12b7a9.png";